import { render, staticRenderFns } from "./DropdownMultiselect.vue?vue&type=template&id=19f1cc91&"
import script from "./DropdownMultiselect.vue?vue&type=script&lang=ts&"
export * from "./DropdownMultiselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports